<template>
	<div class="content">
		<div class="content_head">

			<button type="button" class="button add" @click="Edit='add'">+新增</button>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>作者</th>
						<th>简介</th>
						<th>编辑</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in writer">
						<td class="center">
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td>
							{{i.WriterName}}
						</td>
						<td>
							<div class="multilineText">
								&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{i.WriterDesc}}
							</div>

						</td>

						<td>
							<button type="button" class="button" @click='updateWriter(i)'>
								编辑
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>
		
			<select v-model="pageRows" @change="changePageRows">
				<option value="10">10/页</option>
				<option value="20">20/页</option>
				<option value="30">30/页</option>
		
			</select>
			<button class="button"  :class="{'disabled':down}"  :disabled="down" @click="changePages('down')">下一页</button>
		</div>
		<div class="edit" v-show="Edit!=''">
			<div>
				<p>
					<label>
						<span class="red">*</span>作者姓名:
						<input type="text" v-model="WriterName" placeholder="请输入作者姓名" />
						<span class="err">{{WriterName.length>1?'':'×'}}</span>
					</label>
				</p>
				<p>
					<label>
						<span class="red">&nbsp;&nbsp;</span>作者简介:
						<textarea v-model="WriterDesc" placeholder="请输入作者简介">


						</textarea>

					</label>
				</p>

				<p>
					<button class="button" :class="{'disabled':WriterName.length<=1}" :disabled="WriterName.length<=1" @click="editUsers">{{Edit=='add'? '添加':'修改'}}</button>
					<button class="button" @click="cancel">取消</button>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'writer',
		data() {
			return {

				WriterID: 0,
				WriterName: '',
				WriterDesc: '',

				writer: '',

				Edit: '',
				getData: {},
				clear: {},


				pageIndex: 1,
				pageRows: 10,
				count: 0
			};
		},
		created() {

			this.getData = function() {
				this.$request.request({
					url: 'books/getWriter',
					data: {
						pageCount: this.pageRows,
						pageIndex: this.pageIndex,
						ShopID: this.ShopID,
						UserState: this.UserState
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.writer = res.writer;
						this.count = res.count;
					}
				});
			}
			this.clear = function() {
				this.WriterID = 0;
				this.WriterName = '';
				this.WriterDesc = '';
			}
			this.getData();

		},
		methods: {
			cancel() {
				this.Edit = '';
				this.clear();
			},
			editUsers() {
				this.Edit = '';
				this.$request.request({
					url: 'books/editWriter',
					data: {
						WriterID: this.WriterID,
						WriterName: this.WriterName,
						WriterDesc: this.WriterDesc,
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.$uil.showMessage({
							text: res.message
						});
						this.clear();
						this.getData();
					}
				});


			},
			updateWriter(i) {
				this.Edit = 'update';
				this.WriterID = i.WriterID;
				this.WriterName = i.WriterName;
				this.WriterDesc = i.WriterDesc;

			},


			changePages(s) {
				if (s == 'up') {
					if (this.pageIndex == 1)
						return;
					else
						this.pageIndex--;

				} else {
					if (this.pageIndex * this.pageRows >= this.count)
						return;
					else
						this.pageIndex++;
				}

				this.getData();
			},
			changePageRows() {
				if (this.pageIndex * this.pageRows >= this.count)
					this.pageIndex = 1;
				this.getData();
			}
		},
		computed: {
			up() {
				if (this.pageIndex == 1)
					return true;
				else
					return false;
			},
			down() {
				if (this.pageIndex * this.pageRows >= this.count)
					return true;
				else
					return false;
			},
			page() {
				if (Math.ceil((this.count / this.pageRows)) == 0)
					return this.pageIndex + '/' + 1 + '页';
				else
					return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
			}


		},
		filters: {

		}

	}
</script>

<style>
</style>
